import { ErrorHandler, Injectable, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Location } from '@angular/common';

import { NotificationsService } from '../core/services/notifications.service';
import { PortalModulesService } from '../core/services/portal-modules.service';
import { SpinnerService } from '../core/services/spinner.service';

const DEFAULT_ERROR_MESSAGE = 'An error has occurred';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorInterceptor extends ErrorHandler {
  private location = inject(Location);
  private spinnerService = inject(SpinnerService);
  private portalModulesService = inject(PortalModulesService);
  private notificationsService = inject(NotificationsService);

  //for pages that do not include in module list, add the path here
  private readonly extraPaths = [
    '/account/login',
    '/home/bulletin',
    '/office',
    '/careers',
    '/field/invoicenotes',
    '/careerpath',
    '/dailyhuddledetails',
  ];

  public handleError(error: Error | HttpErrorResponse | any): void {
    super.handleError(error);

    this.spinnerService.closeModal();
    const pageUrl = this.location.path();

    if (!(error instanceof HttpErrorResponse)) {
      this.notificationsService.log(error?.rejection, pageUrl);
      return;
    }

    if (error) {
      const currentModule = this.portalModulesService.modules?.find(
        module => pageUrl.toLowerCase().indexOf(module.ModuleActionName.toLowerCase()) > -1
      );
      const isAcceptablePath = this.extraPaths.some(path => pageUrl.toLowerCase().includes(path));

      if (currentModule?.UseGlobalErrorHandler || isAcceptablePath) {
        const [message, url] = [this.getErrorMessage(error), error.url];
        this.notificationsService.showError(message ?? DEFAULT_ERROR_MESSAGE, url);
      }
    }
  }

  public getErrorMessage(error: HttpErrorResponse): string {
    return error.error?.error ? error.error?.error : error.error?.message;
  }
}
